import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { catchError, map, of } from 'rxjs';

export const reverseAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // If token is already valid, redirect away from auth pages
  if (authService.checkTokenValidity()) {
    return new RedirectCommand(router.parseUrl('/'));
  }

  // Otherwise, if we have no token at all, just allow access
  if (!authService.hasAccessToken()) {
    return true;
  }

  // If we have a token but it's invalid, try to refresh.
  // If refresh succeeds -> redirect away. If it fails -> allow access.
  return authService.refreshToken().pipe(
    map(() => new RedirectCommand(router.parseUrl('/'))),
    catchError(() => of(true)),
  );
};
